module.exports = __webpack_public_path__ + "static/img/red.2526ba6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/red.png
// module id = VnT+
// module chunks = 1